import React from "react";
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { IconRefresh } from "../../../svg";
import { DynamicRadio } from "../../../components/DynamicRadio";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { DynamicInput } from "../../../components/DynamicInput";
import { DynamicTextarea } from "../../../components/DynamicTextarea";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { ButtonOutline } from "../../../components/ButtonOutline";
import { Footer } from "../../../components/Footer";
import { StyledRow } from "../../../styled-components/StyledRow.style";
import { StyledColumn } from "../../../styled-components/StyledColumn.style";

const typeOptions = [
    { value: "civil", name: "tipo", label: "Civil" },
    { value: "eletrica", name: "tipo", label: "Elétrica" },
    { value: "mecanica", name: "tipo", label: "Mecânica" },
];

const ufOptions = [
    { id: "000011", name: "RO" },
    { id: "000012", name: "AC" },
    { id: "000013", name: "AM" },
    { id: "000014", name: "RR" },
    { id: "000015", name: "PA" },
    { id: "000016", name: "AP" },
];

export const NovaSolicitacao = () => {
    return (
        <section>
            <Header />
            <main className="d-flex">
                <Menu></Menu>
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h2>Nova solicitação</h2>
                            <IconRefresh color={"#EE4B21"} />
                        </div>
                        <div>
                            <p className="my-0">
                                Criada em: <b>23/05/2021 - 16:12:55</b>
                            </p>
                        </div>
                    </div>

                    <div className="card">
                        <StyledForm>
                            <div className="form-container">
                                <h2 className="info font-weight-normal">
                                    Engenharia Responsável
                                </h2>
                                <DynamicRadio options={typeOptions} />
                            </div>
                        </StyledForm>

                        <StyledForm direction={"column"}>
                            <h2 className="info font-weight-normal ml-3">
                                Dados do sinistro
                            </h2>

                            <div className="d-flex flex-wrap">
                                <div className="form-container position-relative">
                                    <DynamicSelect
                                        placeholder={"Digite uma sigla"}
                                        label={"Estado sigla UF"}
                                        name={"uf"}
                                        options={ufOptions}
                                        keyValue={"id"}
                                        keyLabel={"name"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicSelect
                                        placeholder={"Digite uma sigla"}
                                        label={"Estado sigla UF"}
                                        name={"uf"}
                                        options={ufOptions}
                                        keyValue={"id"}
                                        keyLabel={"name"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicSelect
                                        placeholder={"Digite uma sigla"}
                                        label={"Estado sigla UF"}
                                        name={"uf"}
                                        options={ufOptions}
                                        keyValue={"id"}
                                        keyLabel={"name"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicSelect
                                        placeholder={"Digite uma sigla"}
                                        label={"Estado sigla UF"}
                                        name={"uf"}
                                        options={ufOptions}
                                        keyValue={"id"}
                                        keyLabel={"name"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicSelect
                                        placeholder={"Digite uma sigla"}
                                        label={"Estado sigla UF"}
                                        name={"uf"}
                                        options={ufOptions}
                                        keyValue={"id"}
                                        keyLabel={"name"}
                                    />
                                </div>

                                <div className="position-relative">
                                    <StyledRow width={"300px"}>
                                        <StyledColumn xs="6">
                                            <div className="position-relative">
                                                <DynamicSelect
                                                    placeholder={
                                                        "Digite uma sigla"
                                                    }
                                                    label={"Estado sigla UF"}
                                                    name={"uf"}
                                                    options={ufOptions}
                                                    keyValue={"id"}
                                                    keyLabel={"name"}
                                                />
                                            </div>
                                        </StyledColumn>
                                        <StyledColumn xs="6">
                                            <div className="position-relative">
                                                <DynamicSelect
                                                    placeholder={
                                                        "Digite uma sigla"
                                                    }
                                                    label={"Estado sigla UF"}
                                                    name={"uf"}
                                                    options={ufOptions}
                                                    keyValue={"id"}
                                                    keyLabel={"name"}
                                                />
                                            </div>
                                        </StyledColumn>
                                    </StyledRow>
                                </div>

                                <div className="position-relative">
                                    <StyledRow width={"300px"}>
                                        <StyledColumn xs="6">
                                            <div className="position-relative">
                                                <DynamicSelect
                                                    placeholder={
                                                        "Digite uma sigla"
                                                    }
                                                    label={"Estado sigla UF"}
                                                    name={"uf"}
                                                    options={ufOptions}
                                                    keyValue={"id"}
                                                    keyLabel={"name"}
                                                />
                                            </div>
                                        </StyledColumn>
                                        <StyledColumn xs="6">
                                            <div className="position-relative">
                                                <DynamicSelect
                                                    placeholder={
                                                        "Digite uma sigla"
                                                    }
                                                    label={"Estado sigla UF"}
                                                    name={"uf"}
                                                    options={ufOptions}
                                                    keyValue={"id"}
                                                    keyLabel={"name"}
                                                />
                                            </div>
                                        </StyledColumn>
                                    </StyledRow>
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Digite uma cidade"}
                                        label={"Cidade"}
                                        name={"cidade"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicSelect
                                        placeholder={"Digite uma sigla"}
                                        label={"Estado sigla UF"}
                                        name={"uf"}
                                        options={ufOptions}
                                        keyValue={"id"}
                                        keyLabel={"name"}
                                    />
                                </div>
                            </div>
                        </StyledForm>

                        <StyledForm direction={"column"}>
                            <h2 className="info font-weight-normal ml-3">
                                Dados do segurado
                            </h2>

                            <div className="d-flex flex-wrap">
                                <div className="form-container position-relative">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Digite uma cidade"}
                                        label={"Cidade"}
                                        name={"cidade"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Digite uma cidade"}
                                        label={"Cidade"}
                                        name={"cidade"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Digite uma cidade"}
                                        label={"Cidade"}
                                        name={"cidade"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Digite uma cidade"}
                                        label={"Cidade"}
                                        name={"cidade"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Digite uma cidade"}
                                        label={"Cidade"}
                                        name={"cidade"}
                                    />
                                </div>
                            </div>
                        </StyledForm>

                        <StyledForm direction={"column"}>
                            <h2 className="info font-weight-normal ml-3">
                                Endereço do sinistro
                            </h2>

                            <div className="d-flex flex-wrap">
                                <div className="position-relative">
                                    <StyledRow width={"300px"}>
                                        <StyledColumn xs="6">
                                            <div className="position-relative">
                                                <DynamicSelect
                                                    placeholder={
                                                        "Digite uma sigla"
                                                    }
                                                    label={"Estado sigla UF"}
                                                    name={"uf"}
                                                    options={ufOptions}
                                                    keyValue={"id"}
                                                    keyLabel={"name"}
                                                />
                                            </div>
                                        </StyledColumn>
                                        <StyledColumn xs="6">
                                            <div className="position-relative">
                                                <DynamicSelect
                                                    placeholder={
                                                        "Digite uma sigla"
                                                    }
                                                    label={"Estado sigla UF"}
                                                    name={"uf"}
                                                    options={ufOptions}
                                                    keyValue={"id"}
                                                    keyLabel={"name"}
                                                />
                                            </div>
                                        </StyledColumn>
                                    </StyledRow>
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Digite uma cidade"}
                                        label={"Cidade"}
                                        name={"cidade"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicSelect
                                        placeholder={"Digite uma sigla"}
                                        label={"Estado sigla UF"}
                                        name={"uf"}
                                        options={ufOptions}
                                        keyValue={"id"}
                                        keyLabel={"name"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicInput
                                        type={"text"}
                                        placeholder={"Digite uma cidade"}
                                        label={"Cidade"}
                                        name={"cidade"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicSelect
                                        placeholder={"Digite uma sigla"}
                                        label={"Estado sigla UF"}
                                        name={"uf"}
                                        options={ufOptions}
                                        keyValue={"id"}
                                        keyLabel={"name"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicSelect
                                        placeholder={"Digite uma sigla"}
                                        label={"Estado sigla UF"}
                                        name={"uf"}
                                        options={ufOptions}
                                        keyValue={"id"}
                                        keyLabel={"name"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicSelect
                                        placeholder={"Digite uma sigla"}
                                        label={"Estado sigla UF"}
                                        name={"uf"}
                                        options={ufOptions}
                                        keyValue={"id"}
                                        keyLabel={"name"}
                                    />
                                </div>

                                <div className="form-container position-relative">
                                    <DynamicSelect
                                        placeholder={"Digite uma sigla"}
                                        label={"Estado sigla UF"}
                                        name={"uf"}
                                        options={ufOptions}
                                        keyValue={"id"}
                                        keyLabel={"name"}
                                    />
                                </div>
                            </div>
                        </StyledForm>

                        <StyledForm direction={"column"}>
                            <h2 className="info font-weight-normal ml-3">
                                Observações
                            </h2>

                            <div className="d-flex flex-wrap">
                                <div className="w-100 position-relative">
                                    <DynamicTextarea
                                        placeholder={"Digite uma cidade"}
                                        label={"Cidade"}
                                        name={"cidade"}
                                    />
                                </div>
                            </div>
                        </StyledForm>

                        <div className="w-100 d-flex justify-content-end align-items-center my-3">
                            <ButtonOutline
                                outlineColor={"#EE4B21"}
                                backgroundColor={"#EE4B21"}
                                color={"#FFF"}
                                text={"Salvar"}
                                maxWidth={"280px"}
                            />
                        </div>
                    </div>
                </StyledDefaultPage>
            </main>

        </section>
    );
};
